'use client'

import { useSession } from 'next-auth/react'
import Image from 'next/image'

import Chatbot from '../chatbot/chatbot'

const AssessmentsPage = () => {
  const { data: session } = useSession()

  return (
    <div className='flex w-full md:items-center md:flex-row flex-col  gap-6 px-4 md:pl-36 md:pr-32 py-12'>
      <div
        className={`
        relative  md:h-[600px] md:w-3/5

        
      `}
      >
        <div className='md:pb-14 pb-5'>
          <h1 className='font-semibold md:text-5xl text-2xl'>AiDA Digital <br className='hidden md:block md:pt-2' />Assistant</h1>
        </div>
        <Image src='/images/chatbotHero.png' alt='Chat Bot Description' width='600' height={600} objectFit='cover' />
      </div>
      <Chatbot accessToken={session?.access_token || ''} />
    </div>
  )
}

export default AssessmentsPage
